import * as React from 'react';
import { FieldInputProps, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Label } from './Label';
import styles from './forms.module.css';

interface AreaProps {
    label: string;
    id: string;
    name: string;
    hideLabel?: boolean;
    placeholder?: string;
    required?: boolean;
    rows?: number;
    disabled?: boolean;
    style?: React.CSSProperties;
    onBlur?: (stuff: any, field: any) => void;
    onChange?: (stuff: any, field: any) => void;
}

const Area: React.FC<AreaProps> = ({
    id,
    label,
    required = false,
    hideLabel = false,
    placeholder,
    rows = 7,
    disabled = false,
    style,
    onBlur,
    onChange,
    ...props
}) => {
    const { t } = useTranslation(['forms']);
    const [field, meta] = useField(props as any);

    const handleBlur = (field: FieldInputProps<any>, e: React.FormEvent<HTMLTextAreaElement>) => {
        if (onBlur) onBlur(field, e);

        field.onBlur(e);
    };

    const handleChange = (field: FieldInputProps<any>, e: React.FormEvent<HTMLTextAreaElement>) => {
        if (onChange) onChange(field, e);

        field.onChange(e);
    };

    return (
        <>
            <Label hideLabel={hideLabel} label={label} id={id} required={required} />
            <textarea
                className={styles.TextArea}
                rows={rows}
                placeholder={placeholder || t('forms:selectors.generic.enterTextHere')}
                {...field}
                disabled={disabled}
                onBlur={(e) => handleBlur(field, e)}
                onChange={(e) => handleChange(field, e)}
                required={required}
                style={style}
                data-qa={`text-area-${id}`}
            />
            {meta.touched && meta.error && (
                <div className={styles.Error}>
                    <span>{meta.error}</span>
                </div>
            )}
        </>
    );
};

export default Area;
